import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

const WHATSAPP_NUMBER = "393347256924";
const WA_PREFILL =
  "Ciao, ho visto il sito VERDEA. Vorrei un preventivo per il mio giardino.";
const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WA_PREFILL)}`;

function WhatsAppIcon({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.768.967-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.892 6.994c-.003 5.45-4.437 9.884-9.886 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
  );
}

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-[#1A3628] text-[#FAF9F6]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-6">
            <p className="overline !text-[#FAF9F6]/70 mb-6">— Contattami</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#FAF9F6]">
              Parliamo del tuo <span className="font-accent italic font-normal">giardino</span>.
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-[#FAF9F6]/75 max-w-md">
              Scrivimi un'email o chiamami — anche via WhatsApp. Ti risponderò
              personalmente con una valutazione e un preventivo senza impegno.
            </p>
          </div>

          <div className="lg:col-span-6 lg:pt-4">
            <div className="grid grid-cols-1 gap-6">
              {/* Email card */}
              <a
                href="mailto:info@verdeagreen.it"
                data-testid="contact-email-card"
                className="group flex items-center justify-between gap-6 border border-[#FAF9F6]/20 hover:border-[#FAF9F6]/60 hover:bg-[#FAF9F6]/[0.03] px-6 py-6 md:px-8 md:py-8 transition-all duration-500"
              >
                <div className="flex items-start gap-5">
                  <span className="inline-flex items-center justify-center w-11 h-11 border border-[#FAF9F6]/30 shrink-0">
                    <Mail size={18} strokeWidth={1.5} />
                  </span>
                  <div>
                    <p className="overline !text-[#FAF9F6]/60">Scrivimi via email</p>
                    <p className="font-serif-display text-2xl md:text-3xl text-[#FAF9F6] mt-1 tracking-tight break-all">
                      info@verdeagreen.it
                    </p>
                  </div>
                </div>
                <ArrowUpRight
                  size={22}
                  strokeWidth={1.5}
                  className="shrink-0 text-[#FAF9F6]/60 group-hover:text-[#FAF9F6] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500"
                />
              </a>

              {/* Phone + WhatsApp card */}
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 border border-[#FAF9F6]/20 px-6 py-6 md:px-8 md:py-8">
                <a
                  href="tel:+393347256924"
                  data-testid="contact-phone-card"
                  className="group flex items-start gap-5 flex-1 hover:opacity-80 transition-opacity"
                >
                  <span className="inline-flex items-center justify-center w-11 h-11 border border-[#FAF9F6]/30 shrink-0">
                    <Phone size={18} strokeWidth={1.5} />
                  </span>
                  <div>
                    <p className="overline !text-[#FAF9F6]/60">Telefono</p>
                    <p className="font-serif-display text-2xl md:text-3xl text-[#FAF9F6] mt-1 tracking-tight">
                      334 725 6924
                    </p>
                  </div>
                </a>
                <a
                  href={waHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp-link"
                  aria-label="Scrivi su WhatsApp"
                  className="inline-flex items-center gap-2 self-start sm:self-center text-[#25D366] hover:text-[#FAF9F6] transition-colors duration-300 shrink-0"
                >
                  <WhatsAppIcon size={26} />
                  <span className="text-xs tracking-[0.2em] uppercase font-medium">
                    WhatsApp
                  </span>
                </a>
              </div>

              {/* Area */}
              <div className="flex items-start gap-5 px-2 pt-2">
                <MapPin size={18} strokeWidth={1.5} className="mt-1 text-[#FAF9F6]/60 shrink-0" />
                <div>
                  <p className="overline !text-[#FAF9F6]/60">Area operativa</p>
                  <p className="text-base text-[#FAF9F6] mt-1">Milano e provincia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
